import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import { useCancellationFees } from "./hooks/useCancellationFees";
import classes from "../../../newBusinessInsightsContent.module.scss";
import Header from "../../../components/Header";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { Box } from "../../../../../shared/Box/Box";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";

const modalInfo = {
  title: "cancellationFeesReport.info.title",
  rows: ["cancellationFeesReport.info.note"],
};

const CancellationFees = () => {
  const { tBi } = useAppTranslation.BusinessInsights();
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useCancellationFees(requestParams);

  const isTableDataEmpty = !isLoading && !data?.reportData?.length;

  const tableData = useMemo(
    () =>
      data?.reportData.map((data) => ({
        patientName: data.client,
        appointmentDatetime: data.appointment_datetime,
        services: data.services,
        cancellationFee: data.cancellation_fee,
        chargedOn: data.charged_on,
      })),
    [data],
  );

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Cancellation Fees"
        selectedClinic={selectedClinic}
        clinics={clinics}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getCancelationFees()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: tBi("patientName"), accessor: "patientName" },
              { data: "Appointment Datetime", accessor: "appointmentDatetime" },
              { data: "Services", accessor: "services" },
              { data: "Cancellation Fee", accessor: "cancellationFee" },
              { data: "Charged On", accessor: "chargedOn" },
            ]}
            data={tableData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isTableDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default CancellationFees;
